<template>
  <div>
    <v-select
      v-model="model"
      :options="formattedOptions"
      :filterable="false"
      @search="onSearch"
      :multiple="(multiple || multiple === 1)"
      :clereable="(multiple || multiple === 1)"
      ref="selectable"
      @input="onInput"
      @option:selected="emt => $emit('option:selected', emt)"
    >
      <template #list-footer>
        <li class="pagination">
          <b-button
            variant="outline-primary"
            size="sm"
            :disabled="!hasPrevPage"
            @click="prevPage"
          >
            <feather-icon icon="ChevronLeftIcon" size="18"/>
          </b-button>
          <b-button
            variant="outline-primary"
            size="sm"
            :disabled="!hasNextPage"
            @click="nextPage"
          >
            <feather-icon icon="ChevronRightIcon" size="18"/>
          </b-button>
        </li>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {debounce} from "lodash";
import {BButton} from "bootstrap-vue";
import axios from "@axios";

export default {
  name: "FacilitiesSelectPaginated",
  components: {
    vSelect,
    BButton,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
  },
  data() {
    return {
      model: null,
      search: "",
      offset: 0,
      limit: 8,
      currentPage: 1,
      meta: null,
      options: [],
    };
  },
  created() {
    this.model = this.value || null;
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
  },
  computed: {
    formattedOptions() {
      return this.options
        .map((item) => {
          return {
            value: item.id,
            label: item.description,
            id_router: item.router?.id
          }
        });
    },
    hasNextPage() {
      if (this.meta) {
        return this.meta.current_page <= this.meta.last_page
      }
      return false;
    },
    hasPrevPage() {
      if (this.meta) {
        return this.meta.current_page - 1 > 0;
      }
      return false;
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.model.value || null);
    },
    fetchData() {
      return new Promise((resolve, reject) => {

        axios.get('/v1/unit', {
          params: {
            q: this.search,
            max: this.limit,
            "page[n]": this.currentPage,
            sortBy: "description",
            sortDesc: false,
          },
        })
          .then(({data}) => {
            this.meta = data.meta;
            this.options = data.data;
            resolve();
          })
          .catch((error) => {
            reject();
            console.log("FacilitiesSelectPaginated: request error", error.response);
          });
      });
    },
    onSearch: debounce(async function (query, loading) {
      if (query.length) {
        loading(true);
        this.search = query;
        this.currentPage = 1;
        await this.fetchData();
        loading(false);
      } else {
        this.currentPage = 1;
        this.search = "";
        await this.fetchData();
      }
    }, 500),
    nextPage() {
      this.currentPage += 1;
    },
    prevPage() {
      this.currentPage--;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: space-around;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;

  &:first-child {
    margin-right: 5px;
  }
}

.pagination button:hover {
  cursor: pointer;
}
</style>
